import React, { createContext, useState, useLayoutEffect } from 'react';
import { useLocalStorage } from '_context/commonHooks';

const MapContext = createContext({
    poi : {},
    rp : {},
    rpDrag : {}, //검색후 드래그했는지 마커를 drag했는지여부
    poiResult: null,
    routes : {},
    selectedId : "",   //검색시 선택된 poi
    selectedTbt:null,  //길찾기시 선택된 tbt
    opts : {},
    rpOpts : {},
    setPoi: () => {}, //검색시 검색된 poi(s) 세팅
    setRP: () => {},  //길찾기 된 route(s) 세팅
    selectedPoi: () => {}, //검색시 선택된 poi 세팅
    setRPOpts:() => {},    //길찾기시 선택된 rpType 세팅
    setPoiResult:() => {}, //검색시 검색된 poi(s) clone해서 전달목적 세팅

    nearPoi: {},
    setNearPoi: () => {}, //길찾기시 경로근처 검색된 poi(s) 세팅
    ktMapIns:null,
    settingKtMapIns:() => {},

    thisPoint:null, //이 위치 검색클릭시 Point
    setThisPoint:() => {},    //이 위치 검색클릭시 Point 세팅

    history:null,
    setHistory:() => {},
    RPhistory:null,
    setRPhistory:() => {}
});

  
function MapProvider (props) {
  const [ktMapIns, setKtMapIns] = useState('');
  const [poi, setPoi] = useState({});
  const [rp, setMapRP] = useState({});
  const [rpDrag, setRpDrag] = useState(false);
  const [routes,setRoutes] = useState([]);
  const [poiResult,setPoiResult] = useState([]);
  const [selectedId, setSelected] = useState("");
  const [nearPoi, setNearPoi] = useState({});
  const [thisPoint, setThisPoint] = useState({});
  const [history, setHistory] = useLocalStorage('GIS_HistoryList',window.localStorage.getItem('GIS_HistoryList') || []);

  const puriffyRPList = () => {
    let tempArr2 = []
    if(window.localStorage.getItem('GIS_RPList')){
      tempArr2 = JSON.parse(window.localStorage.getItem('GIS_RPList')).filter((element) => {
        let check = false
        if(element.rp && element.rp.start && element.rp.start.point && element.rp.end && element.rp.start.end){
          check = true
        }else{
          return false
        }
        if(element.rp && element.rp.wayPoints){
          element.rp.wayPoints.filter((wayPoint) => {
            if(!wayPoint['point']){
              check = false
            }
          })
        }
        if(check){
          return element
        }
      })
    }
    return tempArr2
  }
  
  const [RPhistory, setRPhistory] = useLocalStorage('GIS_RPList',puriffyRPList() || []);

  const [opts, setOpts] = useState({
    isAddr : true,
    expand : {},
  });
  const [rpOpts, setMapRPOpts] = useState({
    rpType : 0,
    //selectedTbt:null,
    routeViewAll:null
  });
  const [selectedTbt, setSelectedTbt] = useState(null);


  const selectedPoi = (selectedId) => {
    setSelected(selectedId);
  };

  const settingKtMapIns = (map) => {
    setKtMapIns(map);
  };

  const setRP = (name,value, mode='', valNot) => {
    let overLapCheck = false
    if(!valNot){
      if(name!=='start' && value && value.point && rp && rp.start && rp.start.point && rp.start.point.lat===value.point.lat && rp.start.point.lng===value.point.lng){
        alert('출발지와 같은장소입니다.')
        overLapCheck = true
      }
      if(name!=='end' && value && value.point && rp && rp.end && rp.end.point && rp.end.point.lat===value.point.lat && rp.end.point.lng===value.point.lng){
        alert('도착지와 같은장소입니다.')
        overLapCheck = true
      }
      //if(value && value.point && rp && rp.wayPoints && mode==='add'){
      if(value && value.point && rp && rp.wayPoints && mode!=='delete'){
        rp.wayPoints.some((wayPoint)=>{
          if(wayPoint.point && wayPoint.point.lat===value.point.lat && wayPoint.point.lng===value.point.lng){
            alert('경유지에 같은장소 이미 입력되었습니다.')
            overLapCheck = true
            return false
          }
        })
      }
      if(overLapCheck){
        return false
      }
    }
    if(name==="all"){
      setMapRP(value)
    }else{
      if(name==='wayPoints'){
        if(mode==='delete' && rp[name] && rp[name].length>0){
          let wayPointsArr = rp[name]
          wayPointsArr.some((element, idx) => {
            if(element.point.lat==value.point.lat && element.point.lng==value.point.lng){
              wayPointsArr.splice(idx, 1)
              return true
            }
          })
          setMapRP({...rp, [name]:wayPointsArr});
        }else if(mode==='add'){
          if(rp[name] && rp[name].length>11){
            alert('경유지 12개를 모두 추가하였습니다.')
            return
          }else{
            setMapRP({...rp, [name]:rp[name]?[...rp[name], value]:[value]});
          }
        }else if(mode==='change'){
          setMapRP({...rp, [name]:value});
        }
      }else{
        if(rp[name]){
          rp[name] = value
        }
        setMapRP({...rp, [name]:value});
      }
    }
    return true
  };

  const changeRPStart = (point, keyword) => {
    if(rp['start']){
      rp['start'] = {...rp['start'], ['point']:point, ['keyword']:keyword}
    }
  }

  const changeRPEnd = (point, keyword) => {
    if(rp['end']){
      rp['end'] = {...rp['end'], ['point']:point, ['keyword']:keyword}
    }
  }

  const changeRPWayPoint = (point, keyword, idx) => {
    if(rp['wayPoints'] && rp['wayPoints'][idx]){
      rp['wayPoints'][idx] = {...rp['wayPoints'][idx], ['point']:point, ['keyword']:keyword}
    }
  }

  const resetRP = () => {
    setMapRP({});
    setMapRPOpts({
    rpType : 0,
    routeViewAll:null
  }); 
 };

 const selExpand = (id,status) =>{
  setOpts({
    ...opts, 
    expand : {
      id, 
      status: status?false:true
    }
  })
 }

 const setMapOpts = (name,value) => {
  setOpts({
    ...opts, 
    [name]: value 
  });
};


const setRPOpts = (name,value) => {
  if(name==="selectedTbt"){
    setSelectedTbt(value)
  }else{
    setMapRPOpts({
      ...rpOpts, 
      [name]: value 
    });
  }
};


  return (
    <MapContext.Provider value={{ 
      poi, selectedId, setPoi, selectedPoi, 
      rp, setRP, resetRP, 
      opts, selExpand, setMapOpts,
      routes, setRoutes,
      poiResult,setPoiResult,
      rpOpts, setRPOpts,
      selectedTbt,setSelectedTbt,
      ktMapIns, settingKtMapIns,
      nearPoi, setNearPoi,
      thisPoint, setThisPoint,
      history, setHistory,
      RPhistory, setRPhistory,
      changeRPStart, changeRPEnd, changeRPWayPoint,
      rpDrag, setRpDrag
     }}>
        {props.children}
    </MapContext.Provider>
  )
}

export { MapContext, MapProvider };
